import React, {useState} from 'react';
import {images} from './images';
import  Showrules from './showrules';
export const Gamepage = () => {

    const [guess_btn,setguess_btn]=useState();
    let [random_numb,setrandom_number]=useState(false);
    let [score,setscore]=useState(0);
    let [showrule,setshowrule]=useState(null);
    let [nullValue,setnullValue]=useState(true);
    const [color,setcolor]=useState({
        btn1:'white',
        btn2:'white',
        btn3:'white',
        btn4:'white',
        btn5:'white',
        btn6:'white',

    });
    
    const number=(e)=>{
        if(e.target.value.lengnth<0)
        {
            setnullValue(false)
        }
        else{
            const numb=e.target.value;
            setguess_btn(numb);
            const updatedColor = {
                btn1: 'white',
                btn2: 'white',
                btn3: 'white',
                btn4: 'white',
                btn5: 'white',
                btn6: 'white',
              };
              updatedColor[`btn${numb}`] = 'blue';
              setcolor(updatedColor);
              setnullValue(false);
        }
      

  
        
    }
    
    if(random_numb===false)
    {
        random_numb=images[0];
    }
    
    const dice=()=>{
        if(nullValue){
            alert("please do select the number");
        }
        else{
            let randomnumber=Math.floor(Math.random()*6);
            random_numb=images[randomnumber];
       
            setrandom_number(random_numb);
   
            console.log("guess btn iS:"+guess_btn);
            console.log("random btn is:"+random_numb.id);
                if(guess_btn == random_numb.id)
                {
                    setscore(score+parseInt(guess_btn));
                    
                    console.log("match");
                }
                else{
                   setscore(score-2);
                    console.log("not match");
                }
                console.log("score is:"+score);
        }
    
        
    }
    const reset=()=>{
        score=0;
        setscore(score);
    }
    
    const showrules=()=>{
        
        setshowrule(!showrule);
        setnullValue(nullValue+1);
        // if(nullValue===1)
        // {
        //     setshowrule(false);
        //     setnullValue(0);
        // }
    }

     
    
  return (
    <div className=''>
        
        
        <div className="guess_button">
        <input className="btn"style={{ backgroundColor: color.btn1 ,color: color.btn1 === 'blue' ? '#FFF':"" }} type="button"value="1"onClick={number}/>
        <input className="btn1"style={{ backgroundColor: color.btn2 ,color: color.btn2 === 'blue' ? '#FFF':""  }} type="button"value="2"onClick={number}/> 
        <input className="btn2"style={{ backgroundColor: color.btn3 ,color: color.btn3 === 'blue' ? '#FFF':"" }} type="button"value="3"onClick={number}/>
        <input className="btn3"style={{ backgroundColor: color.btn4 ,color: color.btn4 === 'blue' ? '#FFF':"" }} type="button"value="4"onClick={number}/>
        <input className="btn4"style={{ backgroundColor: color.btn5 ,color: color.btn5 === 'blue' ? '#FFF':"" }} type="button"value="5"onClick={number}/>
        <input className="btn5"style={{ backgroundColor: color.btn6 ,color: color.btn6 === 'blue' ? '#FFF':"" }} type="button"value="6"onClick={number}/>
        </div>
        <div className="score">
            <p className="score_number">{score}</p>
            <p className="total_score">Total Score</p>
        </div>
        <p className="select">select Number</p>
        <div className="dice d-flex justify-content-center ">
        <img className="dice1" src={random_numb.img} onClick={dice}alt="img1"/>
        </div>
        <p className="para2">Click on Dice to roll</p>
        <div className='d-flex justify-content-center'>
        <input className="reset"type="button"value="Reset Score"onClick={reset}/>
        </div>

        <div className='d-flex justify-content-center'>
        <button className="showrules"onClick={showrules}>{showrule?"Hide":"Help"}</button>
        </div>

        <div>
        {
            showrule && <Showrules/>
            
        }
        </div>
         
        
        
           
    

            
    </div>
  )
}
